import * as React from 'react';

import type {OutcomeType} from 'nutshell-graphql-types';

import {FormAccountAssignments} from '../../forms';

import {SalesAutomationEditorSidebar} from './sidebar/sales-automation-editor-sidebar';

type OwnProps = {
    entityId: string | null | undefined;
    parentId: OutcomeType;
    stagesetId: string;
    isNew: boolean;
};

type Props = OwnProps;

export class AccountAssignmentEditor extends React.PureComponent<Props> {
    sidebarFormSubmitBtnRef: HTMLInputElement | null | undefined;

    render() {
        const {isNew, ...restProps} = this.props;

        return (
            <SalesAutomationEditorSidebar
                onSave={this.handleSidebarFormSave}
                title={isNew ? 'New company type automation' : 'Edit company type automation'}
            >
                <FormAccountAssignments
                    formSubmitBtnRef={(node) => {
                        this.sidebarFormSubmitBtnRef = node;
                    }}
                    {...restProps}
                />
            </SalesAutomationEditorSidebar>
        );
    }

    handleSidebarFormSave = () => {
        if (this.sidebarFormSubmitBtnRef) {
            this.sidebarFormSubmitBtnRef.click();
        }
    };
}
